import { SubjectType } from "@custom-types/base-types";
import { PermissionKey } from "@utils/permissions/permission-matrix";

/**
 * The permission needed to add or edit a plan of the subject.
 * Plans of a project follow the project's rules, every other plan follows the workspace's.
 */
export function getPlanPermission(
  subjectType: SubjectType,
  action: "add" | "edit"
): PermissionKey {
  const domain = subjectType === "PROJECT" ? "project" : "workspace";
  return `${domain}.${action}Plan`;
}
